
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-services/education-loan-for-overseas-education",
      function () {
        return require("private-next-pages/student-services/education-loan-for-overseas-education.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student-services/education-loan-for-overseas-education"])
      });
    }
  